(function () {
  var ROOT_SELECTOR = 'main#MainContent section.main-product--section.klaim-pdp-v2';
  var READY_ATTRIBUTE = 'data-klaim-pdp-media-modal-ready';

  function init() {
    var root = document.querySelector(ROOT_SELECTOR);
    var modal = root && root.querySelector('#galModal');
    var slidesContainer = modal && modal.querySelector('#modalSlidesContainer');
    if (!modal || !slidesContainer || modal.hasAttribute(READY_ATTRIBUTE)) return;

    var slides = Array.prototype.slice.call(slidesContainer.querySelectorAll(':scope > .galSlides'));
    var thumbnails = Array.prototype.slice.call(modal.querySelectorAll('.lightbox-thumbnail'));
    if (!slides.length) return;

    modal.setAttribute(READY_ATTRIBUTE, 'true');
    modal.classList.add('klaim-pdp-media-modal-ready');

    var currentIndex = 0;
    var pageLock = null;
    var drag = null;
    var suppressClickUntil = 0;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function saveStyle(element, property) {
      return {
        value: element.style.getPropertyValue(property),
        priority: element.style.getPropertyPriority(property)
      };
    }

    function restoreStyle(element, property, saved) {
      if (saved.value) {
        element.style.setProperty(property, saved.value, saved.priority);
      } else {
        element.style.removeProperty(property);
      }
    }

    function lockPage() {
      if (pageLock) return;

      var html = document.documentElement;
      var body = document.body;
      var scrollY = window.scrollY || window.pageYOffset || 0;
      pageLock = {
        scrollY: scrollY,
        htmlOverflow: saveStyle(html, 'overflow'),
        htmlOverscroll: saveStyle(html, 'overscroll-behavior'),
        bodyPosition: saveStyle(body, 'position'),
        bodyTop: saveStyle(body, 'top'),
        bodyLeft: saveStyle(body, 'left'),
        bodyRight: saveStyle(body, 'right'),
        bodyWidth: saveStyle(body, 'width'),
        bodyOverflow: saveStyle(body, 'overflow'),
        bodyOverscroll: saveStyle(body, 'overscroll-behavior')
      };

      html.classList.add('klaim-pdp-media-modal-open');
      body.classList.add('klaim-pdp-media-modal-open');
      html.style.setProperty('overflow', 'hidden', 'important');
      html.style.setProperty('overscroll-behavior', 'none', 'important');
      body.style.setProperty('position', 'fixed', 'important');
      body.style.setProperty('top', '-' + scrollY + 'px', 'important');
      body.style.setProperty('left', '0', 'important');
      body.style.setProperty('right', '0', 'important');
      body.style.setProperty('width', '100%', 'important');
      body.style.setProperty('overflow', 'hidden', 'important');
      body.style.setProperty('overscroll-behavior', 'none', 'important');
    }

    function clearDrag() {
      if (!drag) return;
      if (drag.pointerId != null && slidesContainer.hasPointerCapture && slidesContainer.hasPointerCapture(drag.pointerId)) {
        slidesContainer.releasePointerCapture(drag.pointerId);
      }
      drag = null;
      slidesContainer.classList.remove('is-dragging');
      slidesContainer.style.removeProperty('--klaim-modal-drag-x');
    }

    function unlockPage() {
      clearDrag();
      if (modal.classList.contains('is-changing-slide')) {
        modal.classList.remove('is-changing-slide');
      }
      if (!pageLock) {
        document.documentElement.classList.remove('klaim-pdp-media-modal-open');
        document.body.classList.remove('klaim-pdp-media-modal-open', 'body-lock-scroll');
        return;
      }

      var html = document.documentElement;
      var body = document.body;
      var saved = pageLock;
      pageLock = null;

      html.classList.remove('klaim-pdp-media-modal-open');
      body.classList.remove('klaim-pdp-media-modal-open', 'body-lock-scroll');
      restoreStyle(html, 'overflow', saved.htmlOverflow);
      restoreStyle(html, 'overscroll-behavior', saved.htmlOverscroll);
      restoreStyle(body, 'position', saved.bodyPosition);
      restoreStyle(body, 'top', saved.bodyTop);
      restoreStyle(body, 'left', saved.bodyLeft);
      restoreStyle(body, 'right', saved.bodyRight);
      restoreStyle(body, 'width', saved.bodyWidth);
      restoreStyle(body, 'overflow', saved.bodyOverflow);
      restoreStyle(body, 'overscroll-behavior', saved.bodyOverscroll);
      window.scrollTo(0, saved.scrollY);
    }

    function findInitialIndex() {
      var activeThumbnail = modal.querySelector('.lightbox-thumbnail-active');
      var thumbnailIndex = activeThumbnail && Number(activeThumbnail.getAttribute('data-slide-index'));
      if (thumbnailIndex && slides[thumbnailIndex - 1]) return thumbnailIndex - 1;

      var visibleIndex = slides.findIndex(function (slide) {
        return slide.style.display !== 'none' && window.getComputedStyle(slide).display !== 'none';
      });
      return visibleIndex >= 0 ? visibleIndex : currentIndex;
    }

    function updateThumbnails() {
      thumbnails.forEach(function (thumbnail) {
        var active = Number(thumbnail.getAttribute('data-slide-index')) === currentIndex + 1;
        thumbnail.classList.toggle('lightbox-thumbnail-active', active);
        thumbnail.setAttribute('aria-current', active ? 'true' : 'false');
        if (active && modal.classList.contains('open')) {
          thumbnail.scrollIntoView({
            behavior: reducedMotion.matches ? 'auto' : 'smooth',
            block: 'nearest',
            inline: 'center'
          });
        }
      });
    }

    function updateControls() {
      var previous = modal.querySelector('[data-klaim-modal-previous]');
      var next = modal.querySelector('[data-klaim-modal-next]');
      if (previous) previous.disabled = currentIndex === 0;
      if (next) next.disabled = currentIndex === slides.length - 1;
    }

    function render(index, animate) {
      currentIndex = Math.max(0, Math.min(slides.length - 1, index));
      window.slideIndex = currentIndex + 1;
      modal.classList.toggle('is-changing-slide', Boolean(animate && !reducedMotion.matches));

      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === currentIndex;
        slide.classList.toggle('is-active', active);
        slide.classList.toggle('is-before', slideIndex < currentIndex);
        slide.classList.toggle('is-after', slideIndex > currentIndex);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (!active) {
          slide.querySelectorAll('video').forEach(function (video) {
            video.pause();
          });
        }
      });

      updateThumbnails();
      updateControls();
      window.setTimeout(function () {
        modal.classList.remove('is-changing-slide');
      }, reducedMotion.matches ? 0 : 280);
    }

    function goTo(index, animate) {
      if (index === currentIndex || index < 0 || index >= slides.length) {
        slidesContainer.style.removeProperty('--klaim-modal-drag-x');
        return;
      }
      render(index, animate !== false);
    }

    function previous() {
      goTo(currentIndex - 1, true);
    }

    function next() {
      goTo(currentIndex + 1, true);
    }

    function addControls() {
      if (slides.length < 2 || modal.querySelector('[data-klaim-modal-previous]')) return;

      var previousButton = document.createElement('button');
      previousButton.type = 'button';
      previousButton.className = 'klaim-pdp-media-modal__arrow klaim-pdp-media-modal__arrow--previous';
      previousButton.setAttribute('data-klaim-modal-previous', '');
      previousButton.setAttribute('aria-label', 'Previous image');
      previousButton.textContent = '\u2039';

      var nextButton = document.createElement('button');
      nextButton.type = 'button';
      nextButton.className = 'klaim-pdp-media-modal__arrow klaim-pdp-media-modal__arrow--next';
      nextButton.setAttribute('data-klaim-modal-next', '');
      nextButton.setAttribute('aria-label', 'Next image');
      nextButton.textContent = '\u203a';

      modal.appendChild(previousButton);
      modal.appendChild(nextButton);
    }

    function isInteractiveMedia(target) {
      return Boolean(target.closest('video, iframe, model-viewer, product-model, button, a, input, select, textarea'));
    }

    function onPointerDown(event) {
      if (!modal.classList.contains('open') || event.button > 0 || isInteractiveMedia(event.target)) return;
      drag = {
        pointerId: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        x: event.clientX,
        startedAt: performance.now(),
        moved: false
      };
      slidesContainer.classList.add('is-dragging');
      if (slidesContainer.setPointerCapture) slidesContainer.setPointerCapture(event.pointerId);
    }

    function onPointerMove(event) {
      if (!drag || event.pointerId !== drag.pointerId) return;
      var deltaX = event.clientX - drag.startX;
      var deltaY = event.clientY - drag.startY;
      if (!drag.moved && Math.abs(deltaX) < 6 && Math.abs(deltaY) < 6) return;

      drag.moved = true;
      drag.x = event.clientX;
      event.preventDefault();

      if ((currentIndex === 0 && deltaX > 0) || (currentIndex === slides.length - 1 && deltaX < 0)) {
        deltaX *= 0.24;
      }
      slidesContainer.style.setProperty('--klaim-modal-drag-x', deltaX + 'px');
    }

    function finishPointer(event) {
      if (!drag || (event && event.pointerId !== drag.pointerId)) return;

      var deltaX = (event ? event.clientX : drag.x) - drag.startX;
      var elapsed = Math.max(1, performance.now() - drag.startedAt);
      var velocity = Math.abs(deltaX) / elapsed;
      var threshold = Math.max(46, slidesContainer.clientWidth * 0.12);
      var shouldChange = Math.abs(deltaX) >= threshold || (Math.abs(deltaX) >= 24 && velocity >= 0.45);
      var moved = drag.moved;

      clearDrag();
      if (moved) suppressClickUntil = performance.now() + 350;
      if (!shouldChange) return;
      if (deltaX < 0) next();
      if (deltaX > 0) previous();
    }

    function onModalClick(event) {
      var thumbnail = event.target.closest('.lightbox-thumbnail');
      if (thumbnail && modal.contains(thumbnail)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        goTo(Number(thumbnail.getAttribute('data-slide-index')) - 1, true);
        return;
      }

      var previousButton = event.target.closest('[data-klaim-modal-previous]');
      var nextButton = event.target.closest('[data-klaim-modal-next]');
      if (previousButton) previous();
      if (nextButton) next();

      if (performance.now() < suppressClickUntil && slidesContainer.contains(event.target)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }

    function onKeyDown(event) {
      if (!modal.classList.contains('open')) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        previous();
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        next();
      }
      if (event.key === 'Escape') {
        event.preventDefault();
        var closeButton = modal.querySelector('.close');
        if (closeButton) closeButton.click();
      }
    }

    function syncOpenState() {
      var isOpen = modal.classList.contains('open');
      modal.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      if ('inert' in modal) modal.inert = !isOpen;

      if (isOpen) {
        var opening = !pageLock;
        lockPage();
        if (opening) {
          window.requestAnimationFrame(function () {
            render(findInitialIndex(), false);
          });
        }
      } else {
        unlockPage();
      }
    }

    addControls();
    render(0, false);
    slidesContainer.addEventListener('pointerdown', onPointerDown);
    slidesContainer.addEventListener('pointermove', onPointerMove, { passive: false });
    slidesContainer.addEventListener('pointerup', finishPointer);
    slidesContainer.addEventListener('pointercancel', finishPointer);
    modal.addEventListener('click', onModalClick, true);
    document.addEventListener('keydown', onKeyDown);

    new MutationObserver(syncOpenState).observe(modal, {
      attributes: true,
      attributeFilter: ['class']
    });

    window.addEventListener('pageshow', syncOpenState);
    modal.klaimPdpMediaModal = {
      getIndex: function () { return currentIndex; },
      next: next,
      previous: previous,
      goTo: goTo,
      sync: syncOpenState
    };
    syncOpenState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  var attempts = 0;
  var waitForPdp = window.setInterval(function () {
    attempts += 1;
    init();
    if (document.querySelector(ROOT_SELECTOR + ' #galModal[' + READY_ATTRIBUTE + ']') || attempts >= 40) {
      window.clearInterval(waitForPdp);
    }
  }, 100);
})();
